<template>
    <div class="sidebar">
        <!-- Sidebar content -->
        <div class="sidebar-logo">
            <div class="sidebar-inner-logo">
                <router-link
                    to="/">
                    <!-- <span>
                        <h4 class="vh-margin-remove">
                            {{appName.toUpperCase()}}
                        </h4>
                    </span> -->
                    <img
                        :src="'/assets/image/logo-with-title-h.png'" alt="Auto Service App logo">
                </router-link>
            </div>
        </div>

        <ul class="sidebar-menu">
            <li class="sub-menu-title">
                <h4>
                    MENU
                </h4>
            </li>

            <li>
                <router-link
                    :class="{ 'active': $route.path.includes('/dashboard')}"
                    to="/dashboard">
                    <i class="bx bxs-dashboard"></i> Dashboard
                </router-link>
            </li>

            <li>
                <router-link
                    :class="{ 'active': $route.path.includes('/search')}"
                    to="/search">
                    <i class="bx bx-search"></i> General Search
                </router-link>
            </li>

            <li>
                <router-link
                    :class="{ 'active': $route.path.includes('/branches')}"
                    to="/branches">
                    <i class="bx bx-user"></i> Branches
                </router-link>
            </li>

            <li class="sub-menu-title">
                <h4>
                    TRANSACTIONS
                </h4>
            </li>

            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/orders') && !$route.path.includes('/transfers/orders')}"
                    @click="openOrders = !openOrders">
                    <i class="bx bx-notepad"></i> Orders
                    <!-- <span class="vh-margin-small-left">
                        <i class="bx bx-caret-down"></i>
                    </span> -->
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openOrders }"> 
                    <li>
                        <router-link :to="'/orders'"
                            :class="{ 'active': $route.path.includes('/orders') && !$route.path.includes('/orders/overview') && !$route.path.includes('/transfers/orders')}">
                            <i class='bx bx-subdirectory-right'></i> List
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="`/orders/overview?from=${currentMonth.firstDate}&to=${currentMonth.lastDate}`"
                            :class="{ 'active': $route.path.includes('/orders/overview') && !$route.path.includes('/orders/overview') }">
                            <i class='bx bx-subdirectory-right'></i> Overview
                        </router-link>
                    </li>
                </ul>
            </li>

            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/quotations')}"
                    @click="openQuotations = !openQuotations">
                    <i class="bx bx-notepad"></i> Quotations
                    <!-- <span class="vh-margin-small-left">
                        <i class="bx bx-caret-down"></i>
                    </span> -->
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openQuotations }"> 
                    <li>
                        <router-link :to="'/quotations'"
                            :class="{ 'active': $route.path.includes('/quotations') && !$route.path.includes('/quotations/overview')}">
                            <i class='bx bx-subdirectory-right'></i> List
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="`/quotations/overview?from=${currentMonth.firstDate}&to=${currentMonth.lastDate}`"
                            :class="{ 'active': $route.path.includes('/quotations/overview') && !$route.path.includes('/quotations/overview') }">
                            <i class='bx bx-subdirectory-right'></i> Overview
                        </router-link>
                    </li>
                </ul>
            </li>

            <li class="sub-menu-title">
                <h4>
                    INVENTORY
                </h4>
            </li>

            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/parts')}"
                    @click="openParts = !openParts">
                    <i class="bx bx-receipt"></i> Parts
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openParts }"> 
                    <li>
                        <router-link :to="'/parts'"
                            :class="{ 'active': $route.path.includes('/parts') && !$route.path.includes('/parts/stocks') && !$route.path.includes('/parts/sales')}">
                            <i class='bx bx-subdirectory-right'></i> List
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="'/parts/stocks'"
                            :class="{ 'active': $route.path.includes('/parts/stocks')}">
                            <i class='bx bx-subdirectory-right'></i> Stocks
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="`/parts/sales?from=${currentMonth.firstDate}&to=${currentMonth.lastDate}`"
                            :class="{ 'active': $route.path.includes('/parts/sales')}">
                            <i class='bx bx-subdirectory-right'></i> Sales
                        </router-link>
                    </li>
                    
                    
                </ul>

            </li>

            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/purchases') }"
                    @click="openPurchases = !openPurchases">
                    <i class="bx bx-purchase-tag"></i> Purchase Orders
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openPurchases }"> 
                    <li>
                        <router-link :to="'/purchases'"
                            :class="{ 'active': $route.path.includes('/purchases') && !$route.path.includes('/purchases/overview') }">
                            <i class='bx bx-subdirectory-right'></i> List
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="`/purchases/overview?from=${currentMonth.firstDate}&to=${currentMonth.lastDate}`"
                            :class="{ 'active': $route.path.includes('/purchases/overview') && !$route.path.includes('/purchases/overview') }">
                            <i class='bx bx-subdirectory-right'></i> Overview
                        </router-link>
                    </li>
                </ul>
            </li>

            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/suppliers')}"
                    @click="openSuppliers = !openSuppliers">
                    <i class="bx bx-user-pin"></i> Suppliers
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openSuppliers }"> 
                    <li>
                        <router-link :to="'/suppliers'"
                            :class="{ 'active': $route.path.includes('/suppliers') && !$route.path.includes('/suppliers/overview')}">
                            <i class='bx bx-subdirectory-right'></i> List
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="`/suppliers/overview`"
                            :class="{ 'active': $route.path.includes('/suppliers/overview')}">
                            <i class='bx bx-subdirectory-right'></i> Overview
                        </router-link>
                    </li>
                    
                    
                </ul>

            </li>

            <li class="sub-menu-title">
                <h4>
                    LABORS & MECHANICS
                </h4>
            </li>


            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/labors')}"
                    @click="openLabors = !openLabors">
                    <i class="bx bx-receipt"></i> Labors
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openLabors }"> 
                    <li>
                        <router-link :to="'/labors'"
                            :class="{ 'active': $route.path.includes('/labors') && !$route.path.includes('/labors/sales')}">
                            <i class='bx bx-subdirectory-right'></i> List
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="`/labors/sales?from=${currentMonth.firstDate}&to=${currentMonth.lastDate}`"
                            :class="{ 'active': $route.path.includes('/labors/sales')}">
                            <i class='bx bx-subdirectory-right'></i> Sales
                        </router-link>
                    </li>
                    
                    
                </ul>

            </li>

            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/mechanics')}"
                    @click="openMechanics = !openMechanics">
                    <i class="bx bx-wrench"></i> Mechanics
                    <!-- <span class="vh-margin-small-left">
                        <i class="bx bx-caret-down"></i>
                    </span> -->
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openMechanics }"> 
                    <li>
                        <router-link :to="'/mechanics'"
                            :class="{ 'active': $route.path.includes('/mechanics') && !$route.path.includes('/mechanics/commissions')}">
                            <i class='bx bx-subdirectory-right'></i> List
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="`/mechanics/commissions?from=${currentMonth.firstDate}&to=${currentMonth.lastDate}`"
                            :class="{ 'active': $route.path.includes('/mechanics/commissions')}">
                            <i class='bx bx-subdirectory-right'></i> Commissions
                        </router-link>
                    </li>
                    
                    
                </ul>

            </li>

            <li class="sub-menu-title">
                <h4>
                    CUSTOMERS & VEHICLES
                </h4>
            </li>

            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/customers')}"
                    @click="openCustomers = !openCustomers">
                    <i class="bx bx-receipt"></i> Customers
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openCustomers }"> 
                    <li>
                        <router-link :to="'/customers'"
                            :class="{ 'active': $route.path.includes('/customers') && !$route.path.includes('/customers/overview')}">
                            <i class='bx bx-subdirectory-right'></i> List
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="`/customers/overview`"
                            :class="{ 'active': $route.path.includes('/customers/overview')}">
                            <i class='bx bx-subdirectory-right'></i> Overview
                        </router-link>
                    </li>
                    
                    
                </ul>

            </li>

            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/vehicles')}"
                    @click="openVehicles = !openVehicles">
                    <i class="bx bx-user-pin"></i> Vehicles
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openVehicles }"> 
                    <li>
                        <router-link :to="'/vehicles'"
                            :class="{ 'active': $route.path.includes('/vehicles') && !$route.path.includes('/vehicles/overview')}">
                            <i class='bx bx-subdirectory-right'></i> List
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="`/vehicles/overview`"
                            :class="{ 'active': $route.path.includes('/vehicles/overview')}">
                            <i class='bx bx-subdirectory-right'></i> Overview
                        </router-link>
                    </li>
                    
                    
                </ul>

            </li>

            <li class="sub-menu-title">
                <h4>
                    OTHERS
                </h4>
            </li>

            <li>
                <router-link
                    :class="{ 'active': $route.path.includes('/equipments')}"
                    to="/equipments">
                    <i class="bx bx-wrench"></i> Equipments
                </router-link>
            </li>

            
            <li class="sub-menu-title">
                <h4>
                    SALES & ACCOUNTING
                </h4>
            </li>
            
            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/sales')}"
                    @click="openSales = !openSales">
                    <i class="bx bx-receipt"></i> Sales
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openSales }"> 
                    <li>
                        <router-link
                            :class="{ 'active': $route.path.includes('/sales') && !$route.path.includes('/parts/sales') && !$route.path.includes('/settings/sales') && !$route.path.includes('/sales/comparison')}"
                            :to="`/sales?from=${currentMonth.firstDate}&to=${currentMonth.lastDate}`">
                            <i class='bx bx-subdirectory-right'></i> Overview
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            :class="{ 'active': $route.path.includes('/sales/comparison') }"
                            :to="`/sales/comparison?from=${currentMonth.firstDate}&to=${currentMonth.lastDate}`">
                            <i class='bx bx-subdirectory-right'></i> Comparison
                        </router-link>
                    </li>
                </ul>

            </li>


            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/receivables')}"
                    @click="openReceivables = !openReceivables">
                    <i class="bx bx-receipt"></i> Receivables
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openReceivables }"> 
                    <li>
                        <router-link :to="'/receivables/overview'"
                            :class="{ 'active': $route.path.includes('/receivables/overview')}">
                            <i class='bx bx-subdirectory-right'></i> Overview
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="'/receivables/accounts'"
                            :class="{ 'active': $route.path.includes('/receivables/accounts')}">
                            <i class='bx bx-subdirectory-right'></i> Accounts
                        </router-link>
                    </li>
                </ul>

            </li>

            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/payables')}"
                    @click="openPayables = !openPayables">
                    <i class="bx bx-receipt"></i> Payables
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openPayables }"> 
                    <li>
                        <router-link :to="'/payables/overview'"
                            :class="{ 'active': $route.path.includes('/payables/overview')}">
                            <i class='bx bx-subdirectory-right'></i> Overview
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="'/payables/accounts'"
                            :class="{ 'active': $route.path.includes('/payables/accounts')}">
                            <i class='bx bx-subdirectory-right'></i> Accounts
                        </router-link>
                    </li>
                </ul>

            </li>

            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/expenses')}"
                    @click="openExpenses = !openExpenses">
                    <i class="bx bx-receipt"></i> Expenses
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openExpenses }"> 
                    <li>
                        <router-link :to="'/expenses'"
                            :class="{ 'active': $route.path.includes('/expenses') && !$route.path.includes('/expenses/overview') && !$route.path.includes('/expenses/payments')}">
                            <i class='bx bx-subdirectory-right'></i> List
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="'/expenses/payments'"
                            :class="{ 'active': $route.path.includes('/expenses/payments')}">
                            <i class='bx bx-subdirectory-right'></i> Payments
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="`/expenses/overview?from=${currentMonth.firstDate}&to=${currentMonth.lastDate}`"
                            :class="{ 'active': $route.path.includes('/expenses/overview')}">
                            <i class='bx bx-subdirectory-right'></i> Overview
                        </router-link>
                    </li>
                    
                    
                </ul>

            </li>
            
            <li class="sub-menu-title">
                <h4>
                    SYSTEM & DATA
                </h4>
            </li>

            <li>
                <a class="vh-link-reset"
                    :class="{ 'active': $route.path.includes('/settings')}"
                    @click="openSettings = !openSettings">
                    <i class="bx bx-cog"></i> Settings
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openSettings }"> 
                    <li>
                        <router-link :to="'/settings/sales'"
                            :class="{ 'active': $route.path.includes('/settings/sales')}">
                            <i class='bx bx-subdirectory-right'></i> Sales
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="'/settings/sms'"
                            :class="{ 'active': $route.path.includes('/settings/sms')}">
                            <i class='bx bx-subdirectory-right'></i> SMS
                        </router-link>
                    </li>
                </ul>
            </li>

            <li>
                <router-link
                    :class="{ 'active': $route.path.includes('/accounts')}"
                    to="/accounts">
                    <i class="bx bx-user"></i> User Accounts
                </router-link>
            </li>

            <li>
                <a class="vh-link-reset vh-point"
                    :class="{ 'active': $route.path.includes('/prerequisite')}"
                    @click="openPrerequisites = !openPrerequisites">
                    <i class="bx bx-cog"></i> Prerequisites
                </a>

                <ul class="sub-menu"
                    :class="{ 'open' : openPrerequisites }">
                    
                    <li>
                        <router-link :to="'/prerequisite/part-categories'"
                            :class="{ 'active': $route.path.includes('/prerequisite/part-categories')}">
                            <i class='bx bx-subdirectory-right'></i> Part Categories
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="'/prerequisite/part-brands'"
                            :class="{ 'active': $route.path.includes('/prerequisite/part-brands')}">
                            <i class='bx bx-subdirectory-right'></i> Part Brands
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="'/prerequisite/part-types'"
                            :class="{ 'active': $route.path.includes('/prerequisite/part-types')}">
                            <i class='bx bx-subdirectory-right'></i> Part Types
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="'/prerequisite/part-origins'"
                            :class="{ 'active': $route.path.includes('/prerequisite/part-origins')}">
                            <i class='bx bx-subdirectory-right'></i> Part Origins
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="'/prerequisite/part-qualities'"
                            :class="{ 'active': $route.path.includes('/prerequisite/part-qualities')}">
                            <i class='bx bx-subdirectory-right'></i> Part Qualities
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="'/prerequisite/measurements'"
                            :class="{ 'active': $route.path.includes('/prerequisite/measurements')}">
                            <i class='bx bx-subdirectory-right'></i> Measurements
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="'/prerequisite/payment-methods'"
                            :class="{ 'active': $route.path.includes('/prerequisite/payment-methods')}">
                            <i class='bx bx-subdirectory-right'></i> Payment Methods
                        </router-link>
                    </li>
                    
                </ul>
            </li>


        </ul>
    </div>
    <!-- /# sidebar -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { Dater } from '@/utils';

export default
{
    inject: ["mq"],

    name: 'Sidebar',

    data()
    {
        return {
            openSettings: false,
            openPrerequisites: false,
            openReceivables: false,
            openParts: false,
            openLabors: false,
            openExpenses: false,
            openSales: false,
            openPayables: false,
            openCustomers: false,
            openSuppliers: false,
            openVehicles: false,
            openMechanics: false,
            openOrders: false,
            openQuotations: false,
            openPurchases: false,
        };
    },

    created()
    {
        this.checkMobile();

        this.checkDropdown();
    },

    computed:
    {
        ...mapGetters({
            accessUser: 'auth/accessUser',
            sidebarOpen: 'layout/sidebarOpen',
        }),
        
        isMobile()
        {
            return this.mq.current == 'phone';
        },

        currentDate()
        {
            return Dater.rawToday();
        },

        currentMonth()
        {
            return Dater.firstAndLastDateOfMonth();
        }
    },

    methods:
    {
        ...mapActions({
            toggleSidebar: 'layout/toggleSidebar',
            minimizeSidebar: 'layout/minimizeSidebar',
            maximizeSidebar: 'layout/maximizeSidebar',
        }),

        checkMobile()
        {
            if (this.isMobile) this.minimizeSidebar();
            else this.maximizeSidebar();
        },

        checkDropdown()
        {
            if (this.$route.path.includes('/prerequisite'))
            {
                this.openPrerequisites = true;
            }

            if (this.$route.path.includes('/settings'))
            {
                this.openSettings = true;
            }
        },
    },

    watch:
    {
        isMobile()
        {
            this.checkMobile();
        }
    }
};
</script>

<style scoped>
    .nano-content-style-right {
        right: -17px;
    }
</style>